const HTML_PATTERN = /<!doctype\s+html\b[^>]*>|<!--[\s\S]*?-->|<\?[\s\S]*?\?>|<\/?[A-Za-z][A-Za-z0-9:-]*(?:(?:\s|\/)[^<>]*?)?>/i;

export function containsHtml(value) {
    return typeof value === 'string' && HTML_PATTERN.test(value);
}
